import moment from "moment-timezone";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import apiFactory from "../api";
import logo from "../assets/logo_company.jpg";
import {
  CHATTING,
  conversationTab,
  conversationType,
  conversationTypeMap,
  eventBusType,
  MESSAGE_STATUS,
  PANEL_STATUS,
} from "../config/Constant";
import { useInfoUser } from "../store/UserStore";
import {
  openNotificationError,
  openNotificationSuccess,
  openNotificationWarn,
} from "../utils/Utils";
import { pushNotification } from "../utils/UtilsNotification";
import { useUserPresenceStore } from "./../store/useUserPresenceStore";

// ✅ RxJS stream websocket
import { searchChatEvent$ } from "../api/eventBus";
import { chatEvents$ } from "../api/webSocketRx";
import { sortConversationList } from "../utils/ConversationHelper";

const MenuContext = createContext(null);
export const useMenuContext = () => {
  return useContext(MenuContext);
};

const updateFavicon = (unreadCount) => {
  const canvas = document.createElement("canvas");
  canvas.width = 200;
  canvas.height = 200;
  const ctx = canvas.getContext("2d");
  const size = 200;
  const cornerRadius = 50;
  const img = new Image();
  img.src = logo;
  img.crossOrigin = "anonymous";
  img.onload = () => {
    ctx.beginPath();
    ctx.moveTo(cornerRadius, 0);
    ctx.lineTo(size - cornerRadius, 0);
    ctx.quadraticCurveTo(size, 0, size, cornerRadius);
    ctx.lineTo(size, size - cornerRadius);
    ctx.quadraticCurveTo(size, size, size - cornerRadius, size);
    ctx.lineTo(cornerRadius, size);
    ctx.quadraticCurveTo(0, size, 0, size - cornerRadius);
    ctx.lineTo(0, cornerRadius);
    ctx.quadraticCurveTo(0, 0, cornerRadius, 0);
    ctx.closePath();
    ctx.clip();
    ctx.drawImage(img, 0, 0, size, size);
    if (unreadCount > 0) {
      ctx.fillStyle = "red";
      ctx.beginPath();
      ctx.arc(130, 130, 74, 0, 2 * Math.PI);
      ctx.fill();
      ctx.fillStyle = "white";
      ctx.font = "bold 110px Arial";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      const displayText = unreadCount > 9 ? "9+" : unreadCount;
      ctx.fillText(displayText, 130, 135);
    }
    const newFavicon = document.createElement("link");
    newFavicon.rel = "icon";
    newFavicon.href = canvas.toDataURL("image/png");
    const oldFavicon = document.querySelector("link[rel='icon']");
    if (oldFavicon) {
      document.head.removeChild(oldFavicon);
    }
    document.head.appendChild(newFavicon);
  };
};

export const MenuProvider = ({ children }) => {
  const { languageMap, user } = useInfoUser();
  const { selectedConversationId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const conversationRef = useRef(null);
  const [conversationList, setConversationList] = useState([]);
  const [conversationTs, setConversationTs] = useState(moment());
  const [isMoreConversation, setIsMoreConversation] = useState(false);
  const [isConversationsLoading, setIsConversationsLoading] = useState(false);
  const [isAsRead, setIsAsRead] = useState(false);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [conversationHeight, setConversationHeight] = useState(
    window.innerHeight,
  );
  /**
   * There is 4 kinds of panel status
   * 1. GROUP_INFO: when user click panel button. if user click panel button in second time -> close all panels
   * 2. MEDIA_STORAGE: when user click view all button. if user click back button-> back to GROUP_INFO
   * 3. SEARCH_CHAT: when user click search in chat button. if user click close button -> close search panel
   * 4. SEARCH_CHAT_AFTER_GROUP_INFO: when user click search in chat button after opening GROUP_INFO or MEDIA_STORAGE.
   *                                  if user click close -> back to GROUP_INFO
   */
  const [panelStatus, setPanelStatus] = useState(null);

  /**
   * Conversation search -> call api with this value
   * conversationSearchText -> display search input value
   */
  const [conversationSearchText, setConversationSearchText] = useState("");
  // const [searchInputValue, setSearchInputValue] = useState("");
  /* type -> filter conversation by tab (All, Personal, Group) */
  const [conversationSearch, setConversationSearch] = useState({
    labelIds: [],
    starred: null,
    textSearch: null,
    // maxTs: null,
  });

  //Contact
  const [searchConversationList, setSearchConversationList] = useState([]);
  const [lastSearchConversationTs, setLastSearchConversationTs] =
    useState(moment());
  const [isMoreSearchConversation, setIsMoreSearchConversation] =
    useState(false);
  const searchConversationRef = useRef(null);

  const [searchMessageConversationList, setSearchMessageConversationList] =
    useState([]);

  const searchMailSendConversationRef = useRef(null);
  const searchMailReceiveConversationRef = useRef(null);

  const [messageSearch, setMessageSearch] = useState(null);
  const [dataInput, setDataInput] = useState("");
  const [selectedConversation, setSelectedConversation] = useState(null);
  /**
   * store more selectedMailId and selectedMessageId to when click chat or message search conversation list
   * -> highline converastion list
   */
  const [selectedMailId, setSelectedMailId] = useState(null);
  const [selectedMessageId, setSelectedMessageId] = useState(null);

  const [quotation, setQuotation] = useState(null);

  const conversationContainerRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [lastConversationTs, setLastConversationTs] = useState(null);
  const [isMoreMessage, setIsMoreMessage] = useState(false);
  const [isMessageSearch, setIsMessageSearch] = useState(false);
  const [isMenu, setIsMenu] = useState(false);
  const [previousScrollHeight, setPreviousScrollHeight] = useState(0);
  const [labelSelectedId, setLabelSelectedId] = useState(null);
  const [isModalAddMember, setIsModalAddMember] = useState(false);
  const [isModalAddCC, setIsModalAddCC] = useState(false);
  const [isOpenModalConfirm, setIsOpenModalConfirm] = useState(false);
  const [totalNotificationItem, setTotalNotificationItem] = useState(0);
  const [isOpenModalConfirmSaveEmail, setIsOpenModalConfirmSaveEmail] =
    useState(false);
  const [isDiffHtmlMail, setIsDiffHtmlMail] = useState(false);
  const [isModalLabelGroup, setIsModalLabelGroup] = useState(false);
  const [totalUnreadHidden, setTotalUnreadHidden] = useState(0);
  const [activeKey, setActiveKey] = useState(conversationTab.ALL);

  const activeKeyRef = useRef(activeKey);

  const [isSearching, setIsSearching] = useState(false);
  const [tabs, setTabs] = useState([]);

  const [personalDetail, setPersonalDetail] = useState(null);

  const [keydownMenuOn, setKeydownMenuOn] = useState(true);

  const { fetchStatuses } = useUserPresenceStore();
  const updateUserStatus = useUserPresenceStore(
    (state) => state.updateUserStatus,
  );

  const handleUpdateConversationList = useCallback(
    (updatedData, isSearch = false) => {
      setConversationList((prevList) => {
        if (Array.isArray(updatedData)) {
          return sortConversationList([...updatedData], isSearch);
        }

        const index = prevList.findIndex(
          (item) => item.conversationId === updatedData?.conversationId,
        );

        if (index !== -1) {
          const newList = [...prevList];
          newList[index] = {
            ...newList[index],
            ...updatedData,
          };
          return sortConversationList(newList);
        } else {
          return sortConversationList([updatedData, ...prevList]);
        }
      });
    },
    [],
  );

  const resetAndReloadConversations = async () => {
    setIsConversationsLoading(true);
    setConversationList([]);
    setLastConversationTs(null);
    setIsMoreConversation(false);

    try {
      const request = {
        limit: CHATTING.CONVERSATION_LIMIT,
        maxTs: null,
        search: {
          ...conversationSearch,
        },
      };

      const result = await apiFactory.userConversationApi.getList(request);

      if (result?.status === 200 && result?.data) {
        handleUpdateConversationList(result?.data);
        getUnread(result?.data);

        if (result?.data.length > 0) {
          const lastItem = result?.data[result?.data.length - 1];

          setLastConversationTs(lastItem.lastMessageTs);

          setIsMoreConversation(
            result?.data?.length === CHATTING.CONVERSATION_LIMIT,
          );
        } else {
          setIsMoreConversation(false);
        }
      }
    } catch (error) {
      console.error("Reset conversation error:", error);
    } finally {
      setIsConversationsLoading(false);
    }
  };

  const handleReloadConversation = () => {
    setConversationSearch({
      labelIds: [],
      types: [],
      isUnread: false,
      starred: null,
    });

    if (conversationRef.current) {
      conversationRef.current.scrollTop = 0;
    }

    if (searchConversationRef.current) {
      searchConversationRef.current.scrollTop = 0;
    }

    if (searchMailReceiveConversationRef.current) {
      searchMailReceiveConversationRef.current.scrollTop = 0;
    }
    if (searchMailSendConversationRef.current) {
      searchMailSendConversationRef.current.scrollTop = 0;
    }

    setActiveKey("ALL");
    navigate("/conversation");
  };

  const onBackToConversations = () => {
    navigate("/conversation");
  };

  const calculateConversationListHeight = () => {
    /**
     * Search conversation height = 32
     * Label height = 35
     * Conversation tab height = 85
     * last 35 is to shorter than real scroll height
     */
    if (isSearching) {
      setConversationHeight(windowHeight - 32 - 85 - 30);
    } else {
      setConversationHeight(windowHeight - 32 - 35 - 85 - 30);
    }
  };

  /**
   * request body:
   * 1. limit
   * 2. maxTs
   * 3. search: {
   *      labelIds: [],
   *      type: [],
   *      isUnread: false,
   *      starred: null,
   *      textSearch: null,
   *      isNotification: false,
   *    }
   */
  const fetchConversationsData = async (request) => {
    setIsConversationsLoading(true);

    const result = await apiFactory.userConversationApi.getList(request);
    if (result?.status !== 200) return;

    handleUpdateConversationList(result?.data, request?.isSearch);
    getUnread(result?.data);

    if (result?.data?.length > 0) {
      setLastConversationTs(
        result?.data[result?.data?.length - 1].lastMessageTs,
      );
      setIsMoreConversation(
        result?.data?.length === CHATTING.CONVERSATION_LIMIT,
      );
    } else {
      setIsMoreConversation(false);
    }
    setIsConversationsLoading(false);
  };

  const fetchConversationsSearchMessageData = async (request) => {
    setIsConversationsLoading(true);
    const result =
      await apiFactory.conversationApi.getListMessageSearch(request);

    if (result?.status !== 200) return;

    const conversationList = Array.from(
      new Map([...result?.data].map((i) => [i.messageId, i])).values(),
    );

    handleUpdateConversationList(conversationList);

    if (result?.data?.length > 0) {
      setLastConversationTs(result?.data[result?.data?.length - 1].createdAt);

      setIsMoreConversation(
        result?.data?.length === CHATTING.CONVERSATION_LIMIT,
      );
    } else {
      setIsMoreConversation(false);
    }
    setIsConversationsLoading(false);
  };

  const fetchConversationsSearchMailData = async (request) => {
    if (
      !request?.search?.searchContent ||
      request?.search?.searchContent?.trim().length === 0
    )
      return;

    const result = await apiFactory.userMailApi.getPage(request);

    if (result?.status !== 200) return;

    if (result?.data?.items?.length > 0) {
      setConversationList([...result?.data?.items]);
      setLastConversationTs(
        result?.data?.items[result?.data?.items?.length - 1].createdAt,
      );
    } else {
      setConversationList([]);
    }
  };

  const fetchConversationsSearchLetterData = async (request) => {
    if (
      !request?.search?.searchContent ||
      request?.search?.searchContent?.trim().length === 0
    )
      return;

    const result = await apiFactory.letterApi.getPage(request);

    if (result?.status !== 200) return;

    if (result?.data?.items?.length > 0) {
      setConversationList([...result?.data?.items]);
      setLastConversationTs(
        result?.data?.items[result?.data?.items?.length - 1].createdAt,
      );
    } else {
      setConversationList([]);
    }
  };

  const fetchMoreConversations = async () => {
    if (isConversationsLoading || !isMoreConversation) return;

    setIsConversationsLoading(true);

    if (!conversationList || conversationList?.length === 0) {
      setIsConversationsLoading(false);
      return;
    }

    const request = {
      limit: CHATTING.CONVERSATION_LIMIT,
      search: { ...conversationSearch },
      isSearch: conversationTab.CONTACT_CHAT === activeKey,
    };

    const pinnedConversationTs =
      conversationList?.[conversationList?.length - 1]?.pinnedConversationTs;

    if (pinnedConversationTs) {
      request.search.lastPinnedTs = pinnedConversationTs;
    } else {
      request.search.isPersonal = request?.search?.isSearch
        ? null
        : conversationList?.[conversationList?.length - 1]?.type ===
          conversationType.PERSONAL;
      request.search.maxTs =
        conversationList?.[conversationList?.length - 1]?.lastMessageAt;
    }

    const result = await apiFactory.userConversationApi.getList(request);

    if (result?.data && result?.data?.length > 0) {
      const mergedList = [...conversationList, ...result.data];
      const uniqueList = Array.from(
        new Map(
          mergedList.map((item) => [item?.conversationId, item]),
        ).values(),
      );

      getUnread(uniqueList);
      handleUpdateConversationList(uniqueList, request.isSearch);

      setLastConversationTs(result.data[result.data.length - 1].lastMessageTs);
    }
    setIsMoreConversation(result?.data?.length === CHATTING.CONVERSATION_LIMIT);
    setIsConversationsLoading(false);
  };

  const fetchMoreSearchChat = async () => {
    if (isConversationsLoading || !isMoreConversation) return;

    setIsConversationsLoading(true);
    const result = await apiFactory.conversationApi.getListMessageSearch({
      limit: CHATTING.CONVERSATION_LIMIT,
      maxTs: conversationList?.[conversationList?.length - 1].createdAt,
      search: { searchContent: conversationSearch?.textSearch },
    });

    const data = result?.data ?? [];
    if (data.length) {
      const newConversationList = Array.from(
        new Map(
          [...conversationList, ...data].map((i) => [i.messageId, i]),
        ).values(),
      );

      handleUpdateConversationList(newConversationList);

      if (data.length < CHATTING.CONVERSATION_LIMIT) {
        setIsMoreConversation(false);
      }
    } else {
      setIsMoreConversation(false);
    }

    setIsConversationsLoading(false);
  };

  const fetchMoreMailConversations = async (type) => {
    if (
      !conversationSearch?.textSearch ||
      conversationSearch?.textSearch?.trim().length === 0
    )
      return;

    const result = await apiFactory.userMailApi.getPage({
      limit: CHATTING.CONVERSATION_LIMIT,
      maxTs: conversationList[conversationList?.length - 1]?.createdAt,
      direction: "DESC",
      search: {
        searchContent: conversationSearch?.textSearch,
        isHost: type === conversationTab.SEARCH_MESSAGE_SEND,
      },
    });

    const data = result?.data?.items ?? [];
    if (data.length) {
      setConversationList((prev) => [...prev, ...data]);
    }
  };

  const fetchMoreMailConversationsV2 = async (type) => {
    if (
      !conversationSearch?.textSearch ||
      conversationSearch?.textSearch?.trim().length === 0
    )
      return;

    const result = await apiFactory.letterApi.getPage({
      limit: CHATTING.CONVERSATION_LIMIT,
      maxTs: conversationList[conversationList?.length - 1]?.createdAt,
      direction: "DESC",
      search: {
        searchContent: conversationSearch?.textSearch,
        isHost: type === conversationTab.SEARCH_MESSAGE_SEND,
      },
    });

    const data = result?.data?.items ?? [];
    if (data.length) {
      setConversationList((prev) => [...prev, ...data]);
    }
  };

  const showModalLabel = () => {
    setIsModalLabelGroup(true);
    setIsMenu(false);
  };

  const changeUnread = (conversation) => {
    if (conversation?.type === "NOTIFICATION") {
      apiFactory.letterApi.changeUnread({
        conversationId: conversation?.conversationId,
      });
    } else {
      apiFactory.conversationApi.changeUnread({
        userConversationId: conversation?.userConversationId,
      });
    }
  };

  const seenReaction = (userConversationId) => {
    if (!userConversationId) return;

    apiFactory.conversationApi.seenReaction({
      userConversationId: userConversationId,
    });
  };

  const onChangeUnreadConversation = (conversation) => {
    if (!conversation) return;

    const isUnread = conversation.unreadCount > 0;
    const hasReactionNotSeen = conversation.seenReaction === false;

    if (isUnread) changeUnread(conversation);
    if (hasReactionNotSeen) seenReaction(conversation.userConversationId);

    setConversationList((prevList) => {
      if (activeKeyRef.current === conversationTab.UNREAD) {
        return prevList.filter(
          (item) => item.conversationId !== conversation.conversationId,
        );
      }

      return prevList.map((item) => {
        if (item.conversationId === conversation.conversationId) {
          return {
            ...item,
            unreadCount: 0, // Reset về 0
            reactionPreview: hasReactionNotSeen ? null : item.reactionPreview,
            seenReaction: hasReactionNotSeen ? true : item.seenReaction,
          };
        }
        return item;
      });
    });
  };

  const onChangeConversation = useCallback(
    (conversation) => {
      if (activeKey === conversationTab.SEARCH_CHAT) {
        setSelectedMessageId(conversation?.messageId);
      }

      if (
        [
          conversationTab.SEARCH_MESSAGE_RECEIVE,
          conversationTab.SEARCH_MESSAGE_SEND,
        ].includes(activeKey)
      ) {
        setSelectedMailId(conversation?.mailId);
      }

      if (
        [
          conversationTab.NEW_SEARCH_MESSAGE_RECEIVE,
          conversationTab.NEW_SEARCH_MESSAGE_SEND,
        ].includes(activeKey)
      ) {
        setSelectedMailId(conversation?.letterId);
      }

      if (conversation?.conversationId === selectedConversation?.conversationId)
        return;

      handleChangeConversation(conversation);
    },
    [
      activeKey,
      selectedConversation,
      conversationList,
      conversationTab,
      isDiffHtmlMail,
      labelSelectedId,
    ],
  );

  const jumpToSearchChat = (conversation) => {
    setSelectedMessageId(conversation?.messageId);

    if (conversation?.conversationId === selectedConversation?.conversationId) {
      navigate(
        `/conversation/chat/${conversation?.conversationId}?jumpMessageId=${conversation?.messageId}`,
      );

      return;
    }

    onChangeUnreadConversation(conversation);

    navigate(
      `/conversation/chat/${conversation?.conversationId}?jumpMessageId=${conversation?.messageId}`,
    );
    setQuotation(null);

    searchChatEvent$.next({
      type: eventBusType.SEARCH_CHAT,
      payload: conversation,
    });
  };

  const handleChangeConversation = (conversation) => {
    onChangeUnreadConversation(conversation);

    if (
      [
        conversationType.PERSONAL,
        conversationType.GROUP,
        conversationType.SYSTEM,
        conversationType.SELF,
      ].includes(conversation?.type)
    ) {
      navigate(`/conversation/chat/${conversation?.conversationId}`);
    }

    if (
      [conversationType.DRAFT, conversationType.SCHEDULE].includes(
        conversation?.type,
      )
    ) {
      navigate(`/conversation/draft-mail/${conversation?.conversationId}`);
    }

    if (
      conversation?.type === conversationType.NOTIFICATION &&
      conversation?.version === 2
    ) {
      navigate(`/conversation/new-mail/${conversation?.conversationId}`);
    }

    if (
      conversation?.type === conversationType.NOTIFICATION &&
      !conversation?.version
    ) {
      navigate(`/conversation/mail/${conversation?.conversationId}`);
    }

    setQuotation(null);
  };

  const onChangeConversationBeforeCloseModalSavedEmail = (conversation) => {
    setIsOpenModalConfirmSaveEmail(false);
    handleChangeConversation(conversation);
    setQuotation(null);
  };

  const onSwitchNotification = () => {
    navigate("/conversation/draft-mail");
  };

  useEffect(() => {
    if (location.pathname === "/conversation/draft-mail") {
      setSelectedConversation({ type: conversationType.DRAFT });
    }
    if (location.pathname === "/conversation") {
      setSelectedConversation(null);
    }
  }, [location.pathname]);

  const consumeEvent = (message) => {
    let conversationUpdated = { ...selectedConversation };
    conversationUpdated.lastMessage = message.content;
    conversationUpdated.lastMessageTs = message.createdAt;
    conversationUpdated.updatedAt = message.createdAt;
  };

  const onChangeConversationTab = (key) => {
    if (activeKey === key) return;

    setActiveKey(key);
    setConversationList([]);
    setIsMoreConversation(true);
    setConversationSearch({
      ...conversationSearch,
      ...conversationTypeMap[key],
    });
  };

  const updateConversationList = (
    basicConversationInfo,
    announcer,
    message,
    type,
  ) => {
    if (!basicConversationInfo?.conversationId) return;

    if (
      user?.userId === announcer?.userId &&
      message?.contentType === MESSAGE_STATUS.CREATE_PERSONAL
    ) {
      return;
    }

    setConversationList((prev) => {
      const old = prev.find(
        (x) => x?.conversationId === basicConversationInfo?.conversationId,
      );

      const newInfo = {
        ...old,
        ...basicConversationInfo,
        alarm: old?.alarm,
        members: basicConversationInfo?.members || old?.members,
        totalMember:
          basicConversationInfo?.members?.length ||
          old?.totalMember ||
          old?.members?.length,
        pinnedConversationTs: old?.pinnedConversationTs || null,
      };

      if (newInfo?.type === conversationType.PERSONAL) {
        newInfo.avatar = old?.avatar;
      }

      if (user?.userId !== announcer?.userId) {
        if (selectedConversation?.conversationId === newInfo?.conversationId) {
          newInfo.unreadCount = 0;
          changeUnread(selectedConversation);
        } else {
          newInfo.unreadCount = (old?.unreadCount || 0) + 1;
        }
      }

      const filtered = prev.filter(
        (x) => x?.conversationId !== newInfo?.conversationId,
      );

      return sortConversationList([...filtered, newInfo]);
    });
  };

  const updateMarkRead = () => {
    setConversationList((prevList) => {
      const hasUnread = prevList.some((c) => c.unreadCount > 0);
      if (!hasUnread) return prevList;

      const updatedList = prevList.map((c) => ({
        ...c,
        unreadCount: 0,
      }));

      return updatedList;
    });
  };

  const updateReactionPreview = (conversationId, reactionPreview) => {
    if (reactionPreview?.reactionType === "CANCEL") return;

    if (
      selectedConversation?.conversationId === conversationId &&
      selectedConversation?.userConversationId
    ) {
      seenReaction(selectedConversation.userConversationId);
      return;
    }

    setConversationList((prevList) => {
      const updatedList = prevList.map((c) =>
        c.conversationId === conversationId
          ? {
              ...c,
              seenReaction: false,
              reactionPreview: { ...reactionPreview },
            }
          : c,
      );

      return sortConversationList(updatedList);
    });
  };

  const updateConversationListAfterSharingV2 = (eventData) => {
    const { basicConversationInfos, announcer, message, type } =
      eventData || {};
    if (!basicConversationInfos?.length) return;

    for (const basicConversationInfo of basicConversationInfos) {
      updateConversationList(basicConversationInfo, announcer, message, type);
    }
  };

  const updateConversationListAfterSharing = (
    basicConversationInfos,
    announcer,
  ) => {
    if (!basicConversationInfos?.length) return;

    let shouldChangeUnread = false;

    const currentTab = activeKeyRef.current;

    setConversationList((prevList) => {
      const conversationMap = new Map(
        prevList.map((item) => [item.conversationId, item]),
      );

      for (const incoming of basicConversationInfos) {
        const isMatchingTab = checkIsMatchingActiveKey(
          incoming,
          currentTab,
          announcer,
        );
        const isExistInList = conversationMap.has(incoming?.conversationId);

        if (!isMatchingTab && !isExistInList) {
          continue;
        }

        const oldItem = conversationMap.get(incoming?.conversationId);

        if (user?.userId !== announcer?.userId) {
          if (
            selectedConversation?.conversationId === incoming?.conversationId
          ) {
            incoming.unreadCount = 0;
            shouldChangeUnread = true;
          } else {
            incoming.unreadCount = (oldItem?.unreadCount || 0) + 1;
          }
        }

        conversationMap.set(incoming?.conversationId, {
          ...oldItem,
          ...incoming,
          members: incoming?.members ?? oldItem?.members,
          pinnedConversationTs:
            incoming?.pinnedConversationTs ?? oldItem?.pinnedConversationTs,
        });
      }

      return sortConversationList(Array.from(conversationMap.values()));
    });

    if (shouldChangeUnread && selectedConversation) {
      changeUnread(selectedConversation);
    }
  };

  const refreshChatMessage = () => {
    setIsMessageSearch(false);
    setPreviousScrollHeight(0);
    setMessageSearch({
      ...messageSearch,
      content: "",
    });
    setIsMenu(false);
  };

  const refreshMailMessage = () => {
    setIsMessageSearch(false);
    setPreviousScrollHeight(0);
    setMessageSearch({
      content: null,
    });
    setIsMenu(false);
  };

  const onCloseChatMessage = () => {
    setIsMessageSearch(false);
    setPreviousScrollHeight(0);

    if (messageSearch?.content?.trim()?.length > 0) {
      setMessageSearch({
        ...messageSearch,
        content: "",
      });
    }

    setIsMenu(false);
  };

  const onSearch = () => {
    setPanelStatus((prev) => {
      if (prev === PANEL_STATUS.SEARCH_CHAT) {
        return null;
      }

      if (prev === PANEL_STATUS.SEARCH_CHAT_AFTER_GROUP_INFO) {
        return PANEL_STATUS.GROUP_INFO;
      }

      if (
        [PANEL_STATUS.GROUP_INFO, PANEL_STATUS.MEDIA_STORAGE].includes(prev)
      ) {
        return PANEL_STATUS.SEARCH_CHAT_AFTER_GROUP_INFO;
      }

      return PANEL_STATUS.SEARCH_CHAT;
    });
  };

  const onChangeLabel = async (value, userConversationId) => {
    if (value === labelSelectedId || !userConversationId) return;

    let request = {
      labelId: value,
      userConversationId,
    };

    const result = await apiFactory.labelApi.bindingLabel(request);

    if (result?.status !== 200 || !result?.data) {
      return openNotificationError(result?.message);
    }

    setLabelSelectedId(value);

    const newConvs = conversationList?.map((cv) =>
      cv?.userConversationId === userConversationId
        ? { ...cv, labelId: value }
        : cv,
    );

    handleUpdateConversationList(newConvs);
  };

  const onChangeStar = async (userConversationId) => {
    const result =
      await apiFactory.conversationApi.changeStar(userConversationId);

    if (result?.status !== 200 || !result?.data) {
      return openNotificationError(result?.message);
    }

    const newConvs = conversationList?.map((cv) =>
      cv?.userConversationId === userConversationId
        ? {
            ...cv,
            starred: result?.data?.starred,
          }
        : cv,
    );

    handleUpdateConversationList(newConvs);
  };

  const openAddMemberModal = () => {
    setIsModalAddMember(true);
    setIsMenu(false);
  };

  const showModalAddCC = () => {
    setIsModalAddCC(true);
    setIsMenu(false);
  };

  const openModalConfirm = () => {
    setIsOpenModalConfirm(true);
    setIsMenu(false);
  };

  const getConversation = async () => {
    if (!selectedConversationId) {
      return;
    }

    try {
      const result = await apiFactory.conversationApi.getConversation(
        selectedConversationId,
      );

      if (result?.status !== 200) {
        navigate("/conversation");
        return;
      }

      setLabelSelectedId(result?.data?.labelId || null);
      setSelectedConversation(result?.data);
    } catch (error) {
      navigate("/conversation");
      return;
    }
  };

  const filterEventToUpdateConversationList = (eventData) => {
    const { basicConversationInfo, announcer, message, type } = eventData || {};
    if (!basicConversationInfo) return;

    const currentTab = activeKeyRef.current;

    const isMatchingTab = checkIsMatchingActiveKey(
      basicConversationInfo,
      currentTab,
      announcer,
    );

    const isExistInList = conversationList.some(
      (conv) => conv.conversationId === basicConversationInfo.conversationId,
    );

    if (isMatchingTab || isExistInList) {
      updateConversationList(basicConversationInfo, announcer, message, type);
    }
  };

  const handleRemovedMeFromGroup = (eventData) => {
    const { basicConversationInfo, message } = eventData || {};
    const conversationIdToRemove = message?.conversationId;
    const selected = selectedConversation;

    const newConversationList = conversationList.filter(
      (conversation) => conversation?.conversationId !== conversationIdToRemove,
    );

    handleUpdateConversationList(newConversationList);
  };

  const handleConversationDeleted = (eventData) => {
    const { message } = eventData || {};
    const conversationIdToDelete = message?.conversationId;
    const messageText = message?.message?.trim();

    if (!conversationIdToDelete) return;

    const newConversationList = conversationList.filter(
      (conversation) => conversation?.conversationId !== conversationIdToDelete,
    );

    handleUpdateConversationList(newConversationList);

    if (messageText?.length > 0) {
      openNotificationWarn(messageText);
      pushNotification(
        messageText,
        conversationIdToDelete || null,
        languageMap,
      );
    }

    const selected = selectedConversation;
    if (selected?.conversationId === conversationIdToDelete) {
      navigate("/conversation");
    }
  };

  const handleExitGroup = (eventData) => {
    const { basicConversationInfo, message } = eventData || {};
    const removedUserIds = message?.removedUserIds || [];
    const isMeExitGroup = removedUserIds.includes(user?.userId);

    if (isMeExitGroup) {
      handleConversationDeleted(eventData);
      return;
    }

    const conversationId = basicConversationInfo?.conversationId;
    if (!conversationId) return;

    const selected = selectedConversation;

    if (selected?.conversationId === conversationId && basicConversationInfo) {
      setSelectedConversation((prev) => ({
        ...prev,
        members: basicConversationInfo?.members,
        totalMember: basicConversationInfo?.totalMember,
        lastMessage: message?.content,
        lastMessageType: MESSAGE_STATUS.EXIT_GROUP,
        lastMessageTs: basicConversationInfo?.lastMessageTs,
        lastSenderId: basicConversationInfo?.lastSenderId,
      }));
    }

    const index = conversationList.findIndex(
      (item) => item?.conversationId === conversationId,
    );
    if (index === -1) return;

    const updated = {
      ...conversationList[index],
      members: basicConversationInfo?.members,
      totalMember: basicConversationInfo?.totalMember,
      lastMessageTs: basicConversationInfo?.lastMessageTs,
      lastSenderId: basicConversationInfo?.lastSenderId,
      lastMessage: message?.content,
      lastMessageType: MESSAGE_STATUS.EXIT_GROUP,
      unreadCount: (conversationList[index].unreadCount || 0) + 1,
    };

    const next = [...conversationList];
    next[index] = updated;

    handleUpdateConversationList(next);
  };

  const handleUpdateEventFile = (eventData) => {
    filterEventToUpdateConversationList(eventData);
  };

  /**
   * Cases disallow to show up desktop notification
   * 1. SEEN_MESSAGE
   * 2. TYPING
   * 3. MARK_READ
   * 4. USER_STATUS_CHANGED
   * 5. doesnt have announcer
   * 6. my message
   * 7. receive from turn off conversation(eventData?.basicConversationInfo?.alarm)
   * Note to check share message -> basicConversationInfos and messages
   */
  const postMessageWebview = (eventData, contentType) => {
    const isSendByMe = eventData?.announcer?.userId === user?.userId;

    if (eventData?.message) {
      if (
        [
          MESSAGE_STATUS.SEEN_MESSAGE,
          MESSAGE_STATUS.TYPING,
          MESSAGE_STATUS.MARK_READ,
          MESSAGE_STATUS.USER_STATUS_CHANGED,
        ].includes(contentType) ||
        !eventData?.announcer ||
        isSendByMe ||
        !eventData?.basicConversationInfo?.alarm
      ) {
        return;
      }
    } else {
      /** else is share message -> post 1 element*/
      const basicConversationInfoPresece =
        eventData?.basicConversationInfos?.find((b) => b?.alarm);
      if (!basicConversationInfoPresece) return;

      const messagePresence = eventData?.messages?.find(
        (e) =>
          e?.conversationId === basicConversationInfoPresece?.conversationId,
      );
      eventData.basicConversationInfo = basicConversationInfoPresece;
      eventData.message = messagePresence;
    }

    eventData && window?.chrome?.webview?.postMessage(eventData);
  };

  const processEventData = (eventData) => {
    if (!eventData) return;
    if (eventData?.event === "session-uuid") return;

    const {
      basicConversationInfo,
      announcer,
      message,
      type,
      basicConversationInfos,
      reactionPreview,
    } = eventData || {};

    const conversationId = basicConversationInfo?.conversationId;

    postMessageWebview(eventData, type);

    switch (type) {
      case MESSAGE_STATUS.SEEN_MESSAGE: {
        const seen = eventData?.seenMessageTs;

        if (selectedConversation?.conversationId !== seen?.conversationId)
          return;

        if (seen?.conversationId) {
          const newConvs = conversationList.map((conv) =>
            conv.conversationId === seen.conversationId
              ? { ...conv, unreadCount: 0 }
              : conv,
          );

          updateConversationList(newConvs);
        }

        break;
      }

      case MESSAGE_STATUS.MARK_READ:
        updateMarkRead();
        break;

      case MESSAGE_STATUS.REACTION_PREVIEW:
        updateReactionPreview(conversationId, reactionPreview);
        break;

      case MESSAGE_STATUS.USER_STATUS_CHANGED: {
        const { userId, status } = eventData.payload || {};
        if (userId && status) {
          updateUserStatus(userId, status);
        }
        break;
      }

      case MESSAGE_STATUS.CREATE_GROUP:
        filterEventToUpdateConversationList(eventData);
        break;

      case MESSAGE_STATUS.REMOVE_MEMBER:
        if (message?.removedUserIds?.includes(user?.userId)) {
          handleRemovedMeFromGroup(eventData);
        } else {
          filterEventToUpdateConversationList(eventData);
        }
        break;

      case MESSAGE_STATUS.DELETE_GROUP:
        handleConversationDeleted(eventData);
        break;

      case MESSAGE_STATUS.EXIT_GROUP:
        handleExitGroup(eventData);
        break;

      case MESSAGE_STATUS.FILE:
        handleUpdateEventFile(eventData);
        break;

      default: {
        if (type === MESSAGE_STATUS.SHARE_MESSAGE && basicConversationInfos) {
          updateConversationListAfterSharing(basicConversationInfos, announcer);
        }

        if (
          ![
            MESSAGE_STATUS.TYPING,
            MESSAGE_STATUS.SEEN_MESSAGE,
            MESSAGE_STATUS.SHARE_MESSAGE,
            MESSAGE_STATUS.REACTION_MESSAGE,
          ].includes(type)
        ) {
          filterEventToUpdateConversationList(eventData);
        }

        break;
      }
    }
  };

  const markAsRead = async () => {
    const result = await apiFactory.userConversationApi.markAsRead();

    if (result?.status !== 200) {
      openNotificationError("error");
    } else {
      updateMarkRead();
      openNotificationSuccess("successfully");
      setTotalUnreadHidden(0);
    }

    setIsAsRead(false);
  };

  const getUnread = async (conversationList) => {
    const result = await apiFactory.userConversationApi.getUnread();

    if (result?.status !== 200) {
      openNotificationError("error");
    } else {
      const unreadDisplay = conversationList?.reduce((total, conversation) => {
        return total + (conversation?.unreadCount || 0);
      }, 0);
      setTotalUnreadHidden(result?.data - unreadDisplay);
    }
  };

  const onFocusConversationSearch = () => {
    if (isSearching) return;

    setActiveKey(conversationTab.CONTACT_CHAT);
    setConversationList([]);
    setIsSearching(true);
    setConversationSearch({
      ...conversationSearch,
      ...conversationTypeMap[conversationTab.CONTACT_CHAT],
    });
  };

  const onUnFocusConversationSearch = () => {
    setActiveKey(conversationTab.ALL);
    setConversationList([]);
    setIsSearching(false);
    setConversationSearch({
      ...conversationSearch,
      ...conversationTypeMap[conversationTab.ALL],
      textSearch: null,
    });
  };

  const checkIsMatchingActiveKey = useCallback(
    (conversation, currentActiveKey, announcer) => {
      const { type, role } = conversation;

      switch (currentActiveKey) {
        case conversationTab.ALL:
          return true;

        case conversationTab.CHAT:
          return [
            conversationType.PERSONAL,
            conversationType.GROUP,
            conversationType.SYSTEM,
            conversationType.SELF,
          ].includes(type);

        case conversationTab.PERSONAL:
          return type === conversationType.PERSONAL;

        case conversationTab.NOTICE:
          return type === conversationType.NOTIFICATION;

        case conversationTab.MESSAGE_RECEIVE:
          return type === conversationType.NOTIFICATION && role !== "HOST";

        case conversationTab.MESSAGE_SEND:
          return type === conversationType.NOTIFICATION && role === "HOST";

        case conversationTab.UNREAD:
          return (
            announcer?.userId !== user?.userId && conversation?.unreadCount > 0
          );

        case conversationTab.SCHEDULE:
          return type === conversationType.SCHEDULE;

        case conversationTab.CONTACT_CHAT:
        case conversationTab.CONTACT_MESSAGE:
        case conversationTab.SEARCH_NOTICE:
        case conversationTab.SEARCH_CHAT:
        case conversationTab.SEARCH_MESSAGE_RECEIVE:
        case conversationTab.SEARCH_MESSAGE_SEND:
          return false;

        default:
          return false;
      }
    },
    [],
  );

  useEffect(() => {
    if (
      selectedConversation?.type === conversationType.PERSONAL &&
      user?.userId
    ) {
      const members = selectedConversation?.members || [];
      const personal = members.find((member) => member?.userId !== user.userId);
      setPersonalDetail(personal || null);
    }
  }, [selectedConversation, user?.userId]);

  useEffect(() => {
    if (user) fetchStatuses();
  }, [user]);

  useEffect(() => {
    const unreadDisplay = conversationList.reduce((total, conversation) => {
      if (conversation?.lastMessageType !== MESSAGE_STATUS.DISABLE_GROUP) {
        return total + (conversation?.unreadCount || 0);
      }
      return total;
    }, 0);

    updateFavicon(unreadDisplay + totalUnreadHidden);
    window?.chrome?.webview?.postMessage({
      type: "UPDATE_UNREAD",
      unreadCount: unreadDisplay + totalUnreadHidden,
    });
  }, [totalUnreadHidden, conversationList]);

  useEffect(() => {
    switch (activeKey) {
      /** normal case */
      case conversationTab.ALL:
        fetchConversationsData({
          limit: CHATTING.CONVERSATION_LIMIT,
          maxTs: null,
          search: {
            labelIds: conversationSearch?.labelIds,
            starred: conversationSearch?.starred,
          },
        });
        break;
      case conversationTab.UNREAD:
        fetchConversationsData({
          limit: CHATTING.CONVERSATION_LIMIT,
          maxTs: null,
          search: {
            isUnread: true,
            labelIds: conversationSearch?.labelIds,
            starred: conversationSearch?.starred,
          },
        });
        break;
      case conversationTab.CHAT:
        fetchConversationsData({
          limit: CHATTING.CONVERSATION_LIMIT,
          maxTs: null,
          search: {
            types: [
              conversationType.GROUP,
              conversationType.PERSONAL,
              conversationType.SELF,
              conversationType.SYSTEM,
            ],
            labelIds: conversationSearch?.labelIds,
            starred: conversationSearch?.starred,
          },
        });
        break;
      case conversationTab.NOTICE:
        fetchConversationsData({
          limit: CHATTING.CONVERSATION_LIMIT,
          maxTs: null,
          search: {
            types: [conversationType.NOTIFICATION],
            labelIds: conversationSearch?.labelIds,
            isNotification: true,
          },
        });
        break;
      case conversationTab.MESSAGE_RECEIVE:
      case conversationTab.MESSAGE_SEND:
        fetchConversationsData({
          limit: CHATTING.CONVERSATION_LIMIT,
          maxTs: null,
          search: {
            types: [conversationType.NOTIFICATION],
            labelIds: conversationSearch?.labelIds,
            isHost: activeKey === conversationTab.MESSAGE_SEND,
            starred: conversationSearch?.starred,
          },
        });
        break;
      /** search case */
      case conversationTab.CONTACT_CHAT:
        fetchConversationsData({
          limit: CHATTING.CONVERSATION_LIMIT,
          maxTs: null,
          isSearch: true,
          search: {
            types: [
              conversationType.GROUP,
              conversationType.PERSONAL,
              conversationType.SELF,
              conversationType.SYSTEM,
            ],
            searchMemberName: conversationSearch?.textSearch,
            isPersonal: true,
          },
        });
        break;
      case conversationTab.CONTACT_MESSAGE:
      case conversationTab.SEARCH_NOTICE:
        fetchConversationsData({
          limit: CHATTING.CONVERSATION_LIMIT,
          maxTs: null,
          search: {
            types: [conversationType.NOTIFICATION],
            searchMemberName: conversationSearch?.textSearch,
            isNotification: activeKey === conversationTab.SEARCH_NOTICE,
          },
        });
        break;
      case conversationTab.SEARCH_CHAT:
        fetchConversationsSearchMessageData({
          limit: CHATTING.CONVERSATION_LIMIT,
          maxTs: null,
          search: {
            searchContent: conversationSearch?.textSearch,
            type: [
              conversationType.GROUP,
              conversationType.PERSONAL,
              conversationType.SELF,
              conversationType.SYSTEM,
            ],
          },
        });
        break;
      case conversationTab.SEARCH_MESSAGE_RECEIVE:
      case conversationTab.SEARCH_MESSAGE_SEND:
        fetchConversationsSearchMailData({
          limit: CHATTING.CONVERSATION_LIMIT,
          maxTs: null,
          direction: "DESC",
          search: {
            searchContent: conversationSearch?.textSearch,
            isHost: activeKey === conversationTab.SEARCH_MESSAGE_SEND,
          },
        });
        break;
      case conversationTab.NEW_SEARCH_MESSAGE_RECEIVE:
      case conversationTab.NEW_SEARCH_MESSAGE_SEND:
        fetchConversationsSearchLetterData({
          limit: CHATTING.CONVERSATION_LIMIT,
          maxTs: null,
          direction: "DESC",
          search: {
            searchContent: conversationSearch?.textSearch,
            isHost: activeKey === conversationTab.NEW_SEARCH_MESSAGE_SEND,
          },
        });
        break;
      case conversationTab.SCHEDULE:
        fetchConversationsData({
          limit: CHATTING.CONVERSATION_LIMIT,
          maxTs: null,
          search: {
            // types: [conversationType.SCHEDULE],
            labelIds: conversationSearch?.labelIds,
            starred: conversationSearch?.starred,
            searchMemberName: conversationSearch?.textSearch,
            isNotification: activeKey === conversationTab.SEARCH_NOTICE,
            isSchedule: true,
          },
        });
        break;
      default:
        console.log("not exist this tab");
    }
  }, [activeKey, conversationSearch]);

  useEffect(() => {
    activeKeyRef.current = activeKey;
  }, [activeKey]);

  useEffect(() => {
    getConversation();
    setKeydownMenuOn(true);
  }, [selectedConversationId]);

  useEffect(() => {
    calculateConversationListHeight();
  }, [isSearching, windowHeight]);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const sub = chatEvents$.subscribe((eventData) => {
      if (!eventData) return;
      processEventData(eventData);
    });

    return () => sub.unsubscribe();
  }, [selectedConversation?.conversationId, user?.userId, activeKey]);

  const values = useMemo(
    () => ({
      isMenu,
      labelSelectedId,
      isModalAddMember,
      isModalAddCC,
      setIsModalAddCC,
      isOpenModalConfirm,
      loading,
      isMoreMessage,
      messageSearch,
      conversationSearch,
      setConversationSearch,
      fetchConversationsData,
      fetchConversationsSearchMessageData,
      conversationContainerRef,
      conversationList,
      conversationTs,
      selectedConversation,
      quotation,
      dataInput,
      isMoreConversation,
      isMessageSearch,
      previousScrollHeight,
      lastConversationTs,
      totalNotificationItem,
      setTotalNotificationItem,
      onChangeConversation,
      onChangeUnreadConversation,
      setLastConversationTs,
      setConversationTs,
      setDataInput,
      consumeEvent,
      setSelectedConversation,
      setQuotation,
      setLoading,
      setIsMoreConversation,
      setIsMoreMessage,
      setMessageSearch,
      onSwitchNotification,
      conversationRef,
      refreshChatMessage,
      setIsMessageSearch,
      setIsMenu,
      setLabelSelectedId,
      setPreviousScrollHeight,
      setIsModalAddMember,
      setIsOpenModalConfirm,
      onSearch,
      onBackToConversations,
      onChangeLabel,
      onChangeStar,
      openAddMemberModal,
      showModalAddCC,
      openModalConfirm,
      setActiveKey,
      activeKey,
      isSearching,
      setIsSearching,
      searchConversationList,
      setSearchConversationList,
      lastSearchConversationTs,
      setLastSearchConversationTs,
      isMoreSearchConversation,
      setIsMoreSearchConversation,
      searchConversationRef,
      searchMessageConversationList,
      setSearchMessageConversationList,
      setConversationList,
      searchMailReceiveConversationRef,
      searchMailSendConversationRef,
      conversationSearchText,
      setConversationSearchText,
      onChangeConversationTab,
      isConversationsLoading,
      setIsConversationsLoading,
      onCloseChatMessage,
      isOpenModalConfirmSaveEmail,
      setIsOpenModalConfirmSaveEmail,
      onChangeConversationBeforeCloseModalSavedEmail,
      updateConversationList,
      getConversation,
      isDiffHtmlMail,
      setIsDiffHtmlMail,
      isModalLabelGroup,
      setIsModalLabelGroup,
      showModalLabel,
      handleChangeConversation,
      refreshMailMessage,
      handleReloadConversation,
      setPersonalDetail,
      personalDetail,
      fetchMoreConversations,
      fetchMoreSearchChat,
      fetchMoreMailConversations,
      fetchMoreMailConversationsV2,
      isAsRead,
      setIsAsRead,
      markAsRead,
      keydownMenuOn,
      setKeydownMenuOn,
      resetAndReloadConversations,
      tabs,
      setTabs,
      onFocusConversationSearch,
      onUnFocusConversationSearch,
      selectedMailId,
      setSelectedMailId,
      selectedMessageId,
      setSelectedMessageId,
      panelStatus,
      setPanelStatus,
      handleUpdateConversationList,
      conversationHeight,
      jumpToSearchChat,
    }),
    [
      conversationSearch,
      isDiffHtmlMail,
      conversationList,
      selectedConversation,
      isMessageSearch,
      messageSearch,
      isMenu,
      labelSelectedId,
      isModalAddMember,
      isModalAddCC,
      isOpenModalConfirm,
      isMoreConversation,
      previousScrollHeight,
      activeKey,
      quotation,
      isConversationsLoading,
      isOpenModalConfirmSaveEmail,
      isModalLabelGroup,
      isSearching,
      searchConversationList,
      lastSearchConversationTs,
      isMoreSearchConversation,
      conversationSearchText,
      searchMessageConversationList,
      personalDetail,
      isAsRead,
      keydownMenuOn,
      loading,
      isMoreMessage,
      conversationTs,
      dataInput,
      lastConversationTs,
      totalNotificationItem,
      tabs,
      selectedMailId,
      selectedMessageId,
      panelStatus,
      handleUpdateConversationList,
      onChangeConversation,
      conversationHeight,
    ],
  );

  return <MenuContext.Provider value={values}>{children}</MenuContext.Provider>;
};
